<template>
    <div class="fixed z:$(comment-modal-zindex) w:full h:full flex jc:flex-end top:0 left:0 {pt:36}@<sm" v-if="opened">
        <div class="w:full max-w:414 h:full flex flex-direction:column jc:center bg:white rel {max-w:none;rt:20}@<sm">
            <div class="px:24 t:center">
                <div class="f:20 font:bold">提醒您！</div>
                <div class="my:24 color:#6F737D">刪除後資料將不保留，確定刪除嗎？</div>
                <div class="t:center {ml:16}>button+button">
                    <button class="btn btn-outline-secondary" @click="cancel" type="button">取消</button>
                    <button class="btn btn-primary" @click="confirm" type="button">確認</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const opened = ref(false);

    const cancel = () => {
        emit("cancel");
        hide();
    };

    const confirm = () => {
        emit("confirm");
        hide();
    };

    const emit = defineEmits(["cancel", "confirm"]);

    const hide = () => {
        opened.value = false;
    }

    const show = () => {
        opened.value = true;
    }

    defineExpose({ hide, show });
</script>
